module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-4.42441db5.mp3";